const LinkedInstanceRender = (params) => {
  return <>{params?.data?.linked_instance?.[0]}</>;
};

export default LinkedInstanceRender;
